export enum SkeletonLoaderTypeEnum {
    TEXT = 'TEXT',
    TITLE = 'TITLE',
    IMAGE = 'IMAGE',
    BUTTON = 'BUTTON',
}
